import { createRoot } from 'react-dom/client';

import './style.scss';
import Style from './Components/Common/Style';
import { isMobile, isTablet } from './utils/functions';
import { closeIcon } from './utils/icons';
import Countdown from './Components/Common/Countdown';

document.addEventListener('DOMContentLoaded', () => {
	const countdownEls = document.querySelectorAll('.wp-block-ctb-countdown-time');
	countdownEls.forEach(countdownEl => {
		const attributes = JSON.parse(countdownEl.dataset.attributes);
		const content = JSON.parse(countdownEl.dataset.content);
		const { cId, hideOnMobile = false, hideOnTablet = false } = attributes;

		const ifHideOnMobile = hideOnMobile && isMobile.matches;
		const ifHideOnTablet = hideOnTablet && isTablet.matches;

		const closeEl = <span onClick={() => {
			countdownEl.classList.add('transformHidden');

			setTimeout(() => {
				countdownEl.style.display = 'none';
			}, 450);
		}}>{closeIcon}</span>

		createRoot(countdownEl).render(!ifHideOnMobile && !ifHideOnTablet ? <>
			<Style attributes={attributes} clientId={cId} />

			<Countdown attributes={attributes} Box={Box} closeEl={closeEl}>
				<div className='countdownExpired' dangerouslySetInnerHTML={{ __html: content }} />
			</Countdown>
		</> : <></>);

		countdownEl?.removeAttribute('data-attributes');
		countdownEl?.removeAttribute('data-content');
	});
});

const Box = (props) => {
	const { is, boxClass, digit, isLabels, label } = props;

	return is && <div className={`countdownItem ${boxClass}`}>
		<span className='digit'>{digit}</span>
		{(isLabels && label) && <label className='label' dangerouslySetInnerHTML={{ __html: label }} />}
	</div>;
};